import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectPinStep } from 'next/entities/pins';
import { ConditionText } from './styled';

export const PinCondition = ({
  operator,
  negated,
  pinName,
  experienceStep: experienceStepId,
}) => {
  const negative = negated || operator === '!=';

  return (
    <ConditionText>
      Pin {pinName || experienceStepId} has {negative ? 'not' : ''} been
      interacted with.
    </ConditionText>
  );
};

PinCondition.propTypes = {
  experienceStep: PropTypes.string,
  operator: PropTypes.string.isRequired,
  pinName: PropTypes.string.isRequired,
  negated: PropTypes.bool,
};

const mapStateToProps = (state, { experienceStep }) => {
  return {
    pinName: selectPinStep(state, experienceStep)?.name,
  };
};

export default connect(mapStateToProps)(PinCondition);
